import { TablePaginationConfig } from 'antd/es/table';

export const normalizeDateRange = (min?: string, max?: string): [string, string] | undefined => {
    if (!min || !max) {
        return undefined;
    }

    return [min, max];
};

export const buildInvoiceQueryParams = ({
    pagination,
    search,
    statusFilter,
    invoiceDates,
    dueDates,
    sorter,
}: {
    pagination?: TablePaginationConfig;
    search?: string;
    statusFilter?: string;
    invoiceDates?: [string, string];
    dueDates?: [string, string];
    sorter?: { field?: string; order?: string };
}): Record<string, unknown> => {
    const params: Record<string, unknown> = {
        page: pagination?.current || 1,
        page_size: pagination?.pageSize,
    };

    if (search) {
        params['search'] = search;
    }

    if (statusFilter) {
        params['invoice_status'] = statusFilter;
    }

    if (invoiceDates) {
        params['invoice_date_min'] = invoiceDates[0];
        params['invoice_date_max'] = invoiceDates[1];
    }

    if (dueDates) {
        params['due_date_min'] = dueDates[0];
        params['due_date_max'] = dueDates[1];
    }

    if (sorter?.field) {
        params['ordering'] = `${sorter.order === 'ascend' ? '' : '-'}${sorter.field}`;
    }

    return params;
};
